// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KJWR","name":"styles_name__1L44e","phone":"styles_phone__Xkuup"};